import React from 'react';
import Robot from '../../assets/gif/robot.gif';
import './Styles/Welcome.scss';
import { IoChatbubbleEllipsesOutline } from "react-icons/io5";

const Welcome = ({ currentUser }) => {
  return (
    <div className="welcome-container">
      <div className="welcome-content">
        <div className="welcome-icon">
          <IoChatbubbleEllipsesOutline />
        </div>
        <div className="welcome-text">
          <h1>
            Welcome,{' '}
            <span className="user-name">{currentUser?.firstName}!</span>
          </h1>
          <p className="message">Select a conversation to start messaging</p>
          <div className="security-badge">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width="16"
              height="16"
            >
              <path
                d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 6c1.4 0 2.5 1.1 2.5 2.5V13c.6 0 1 .4 1 1v4c0 .6-.4 1-1 1h-5c-.6 0-1-.4-1-1v-4c0-.6.4-1 1-1V9.5C9.5 8.1 10.6 7 12 7zm0 1c-.8 0-1.5.7-1.5 1.5V13h3V9.5c0-.8-.7-1.5-1.5-1.5z"
                fill="#34D399"
              />
            </svg>
            <span>End-to-end encrypted</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
